import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
import { DS } from '../ds';
import { Logo } from '../Visuals';
interface FooterProps {
  onNav: (id: string) => void;
}
interface FooterLink {
  label: string;
  id: string;
}
interface FooterColumn {
  title: string;
  links: FooterLink[];
}
const socialLinks = [{
  label: 'Instagram',
  href: 'https://www.instagram.com/alinova.co/',
  icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-449" data-mp="1mfczh9kq9pl6">
        <rect x="2" y="2" width="20" height="20" rx="5" ry="5" data-id="element-450" data-mp="1w827fuh2klbr" />
        <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" data-id="element-451" data-mp="1reh5xsg9p97t" />
        <circle cx="17.5" cy="6.5" r="1.5" data-id="element-452" data-mp="13p4yax0l997m" />
      </svg>
}, {
  label: 'TikTok',
  href: 'https://www.tiktok.com/@alinovaortodoncia?_r=1&_t=ZS-99B99rKhUIv',
  icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-453" data-mp="1ei2917pehpf7">
        <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" data-id="element-454" data-mp="1nbp0wmqhm8j4" />
      </svg>
}, {
  label: 'Facebook',
  href: 'https://www.facebook.com/profile.php?id=61590494495467',
  icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-455" data-mp="vk9jr87p9e0a">
        <path d="M18 2h-3a6 6 0 0 0-6 6v3H7v4h2v8h4v-8h3l1-4h-4V8a2 2 0 0 1 2-2h3z" data-id="element-456" data-mp="14m91y3ugao4t" />
      </svg>
}];
const columns: FooterColumn[] = [{
  title: 'Soluciones',
  links: [{
    label: 'Proceso clínico',
    id: 'proceso'
  }, {
    label: 'Tecnología',
    id: 'tecnologia'
  }, {
    label: 'Kit eco-premium',
    id: 'kit'
  }, {
    label: 'Planes',
    id: 'planes'
  }]
}, {
  title: 'Plataforma',
  links: [{
    label: 'Preguntas frecuentes',
    id: 'faq'
  }, {
    label: 'Nosotros',
    id: 'nosotros'
  }]
}, {
  title: 'Contacto',
  links: [{
    label: 'Soporte',
    id: 'contacto'
  }]
}];
const privacyContent = `
POLÍTICA DE PRIVACIDAD — ALINOVA
Última actualización: julio de 2025

1. RESPONSABLE DEL TRATAMIENTO

ADL Importaciones S.A.S, propietario del establecimiento Labtek Soluciones Dentales 3D, identificado con NIT correspondiente, con domicilio en Colombia, es el responsable del tratamiento de los datos personales recolectados a través del sitio web de Alinova.

2. DATOS QUE RECOLECTAMOS

Recolectamos los siguientes datos cuando usted completa nuestros formularios de contacto:

• Nombre completo

• Correo electrónico

• Número de teléfono

• Modalidad de interés seleccionada

3. FINALIDAD DEL TRATAMIENTO

Los datos recolectados se utilizan exclusivamente para:

• Dar respuesta a su solicitud de información o envío de caso

• Contactarle para el seguimiento comercial y clínico

• Gestionar la relación profesional entre Alinova y el odontólogo u ortodoncista

• Enviar información relevante sobre nuestros servicios cuando así lo autorice

4. DERECHOS DEL TITULAR

Como titular de sus datos personales, usted tiene derecho a conocer, actualizar, rectificar y suprimir su información. Para ejercer estos derechos puede contactarnos a través de WhatsApp al +57 301 653 9065 o al correo electrónico de contacto de Alinova.

5. SEGURIDAD DE LOS DATOS

Alinova implementa medidas técnicas y administrativas razonables para proteger la información personal de accesos no autorizados, pérdida o divulgación indebida.

6. TRANSFERENCIA DE DATOS

Los datos personales no serán vendidos, alquilados ni compartidos con terceros sin su consentimiento, salvo obligación legal.

7. COOKIES

Este sitio web puede utilizar cookies técnicas necesarias para su funcionamiento. No se utilizan cookies de seguimiento publicitario sin consentimiento previo.

8. CAMBIOS A ESTA POLÍTICA

Alinova se reserva el derecho de actualizar esta política. Los cambios serán publicados en este mismo sitio.

9. CONTACTO

Para cualquier consulta relacionada con privacidad y tratamiento de datos:

WhatsApp: +57 301 653 9065

Ubicación: Colombia
`;

// Links ahora oscuros — footer claro
const footerLinkStyle: React.CSSProperties = {
  appearance: 'none',
  background: 'none',
  border: 'none',
  padding: 0,
  textAlign: 'left',
  cursor: 'pointer',
  fontFamily: DS.font.body,
  fontSize: '14px',
  color: DS.color.muted,
  textDecoration: 'none',
  transition: 'color 0.2s'
};
export function Footer({
  onNav
}: FooterProps) {
  const [showPrivacy, setShowPrivacy] = useState(false);
  return <>
      <footer style={{
      background: DS.color.white,
      padding: '64px 24px 28px',
      borderTop: `1px solid ${DS.color.border}`,
      position: 'relative',
      overflow: 'hidden'
    }} data-id="element-457" data-mp="1gmp5vx5vovvq">
        {/* Línea decorativa superior — teal sutil */}
        <div aria-hidden="true" style={{
        position: 'absolute',
        top: 0,
        left: '50%',
        transform: 'translateX(-50%)',
        width: '320px',
        height: '2px',
        background: `linear-gradient(90deg, transparent, ${DS.color.teal}55, transparent)`
      }} data-id="element-458" data-mp="3s913ut6a7dc1" />

        {/* Glow teal muy sutil esquina */}
        <div aria-hidden="true" style={{
        position: 'absolute',
        bottom: '-60px',
        right: '-60px',
        width: '360px',
        height: '360px',
        background: 'radial-gradient(ellipse, rgba(75,199,210,0.05) 0%, transparent 65%)',
        pointerEvents: 'none'
      }} data-id="element-459" data-mp="frmdl1upq3p0" />

        <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        position: 'relative',
        zIndex: 1
      }} data-id="element-460" data-mp="2qk735669xdwo">
          <div className="col-4" style={{
          display: 'grid',
          gridTemplateColumns: '1.5fr 1fr 1fr 1fr',
          gap: '40px',
          marginBottom: '48px'
        }} data-id="element-461" data-mp="3tvct92rrsv69">
            {/* Logo + descripción */}
            <div data-id="element-462" data-mp="1pqslq0vne83">
              <Logo size="md" data-id="element-463" data-mp="1tenotlz08ox" />
              <p style={{
              fontFamily: DS.font.body,
              fontSize: '14px',
              color: DS.color.muted,
              lineHeight: 1.7,
              marginTop: '18px',
              maxWidth: '260px'
            }} data-id="element-464" data-mp="gob4hv7ui4dm">
                El aliado tecnológico para ortodoncia invisible. Planeación
                digital, fabricación precisa y entrega eco-premium.
              </p>

              {/* Badge INVIMA */}
              <div style={{
              marginTop: '20px',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              padding: '7px 14px',
              borderRadius: DS.radius.pill,
              background: DS.color.mint,
              border: `1px solid ${DS.color.aqua}40`
            }} data-id="element-465" data-mp="ughj3cvco3ay">
                <svg width="12" height="12" viewBox="0 0 14 14" fill="none" aria-hidden="true" data-id="element-466" data-mp="191mzlgck9rbv">
                  <path d="M7 1L12 3.5V7C12 9.8 9.8 12.3 7 13C4.2 12.3 2 9.8 2 7V3.5L7 1Z" fill={`${DS.color.teal}20`} stroke={DS.color.teal} strokeWidth="1.2" data-id="element-467" data-mp="1031izqqngmdq" />
                  <path d="M5 7L6.5 8.5L9.5 5.5" stroke={DS.color.tealDeep} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" data-id="element-468" data-mp="ccdw9zc2rs74" />
                </svg>
                <span style={{
                fontFamily: DS.font.body,
                fontSize: '11px',
                fontWeight: 700,
                color: DS.color.tealDeep,
                letterSpacing: '0.05em'
              }} data-id="element-469" data-mp="wrfei8qq6yw8">
                  INVIMA certificado
                </span>
              </div>
            </div>

            {/* Columnas de links */}
            {columns.map(column => <div key={column.title} data-id="element-470" data-mp="92creldboduc">
                <div style={{
              fontFamily: DS.font.heading,
              fontWeight: 700,
              fontSize: '12px',
              color: DS.color.ink,
              marginBottom: '18px',
              textTransform: 'uppercase',
              letterSpacing: '0.09em'
            }} data-id="element-471" data-mp="44ufcm40dii4">
                  {column.title}
                </div>
                <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '11px'
            }} data-id="element-472" data-mp="21rdgd52akni0">
                  {column.title === 'Contacto' && <a href={DS.wa} target="_blank" rel="noopener noreferrer" style={footerLinkStyle} onMouseEnter={e => e.currentTarget.style.color = DS.color.teal} onMouseLeave={e => e.currentTarget.style.color = DS.color.muted} data-id="element-473" data-mp="2fs685i17l4hf">
                      Enviar caso por WhatsApp
                    </a>}
                  {column.links.map(link => <button key={`${column.title}-${link.label}`} type="button" onClick={() => onNav(link.id)} style={footerLinkStyle} onMouseEnter={e => e.currentTarget.style.color = DS.color.teal} onMouseLeave={e => e.currentTarget.style.color = DS.color.muted} data-id="element-474" data-mp="14c97wxnx6y4w">
                      {link.label}
                    </button>)}
                </div>
              </div>)}
          </div>

          {/* Divisor */}
          <div style={{
          height: '1px',
          background: `linear-gradient(90deg, transparent, ${DS.color.aqua}30, transparent)`,
          marginBottom: '24px'
        }} data-id="element-475" data-mp="2172uo0kg4f4m" />

          {/* Redes sociales */}
          <div style={{
          display: 'flex',
          gap: '20px',
          justifyContent: 'center',
          alignItems: 'center',
          marginBottom: '28px',
          paddingBottom: '28px',
          borderBottom: `1px solid ${DS.color.border}`
        }} data-id="element-476" data-mp="18gul2x3z731n">
            {socialLinks.map(social => <a key={social.label} href={social.href} target="_blank" rel="noopener noreferrer" aria-label={`Alinova en ${social.label}`} style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '44px',
            height: '44px',
            borderRadius: '50%',
            background: 'rgba(0, 170, 212, 0.1)',
            color: DS.color.aqua,
            textDecoration: 'none',
            border: '2px solid transparent',
            transition: `background-color 0.25s ${DS.ease.smooth}, color 0.25s ${DS.ease.smooth}, transform 0.25s ${DS.ease.smooth}`
          }} onMouseEnter={e => {
            e.currentTarget.style.background = DS.color.aqua;
            e.currentTarget.style.color = '#fff';
            e.currentTarget.style.transform = 'scale(1.1)';
          }} onMouseLeave={e => {
            e.currentTarget.style.background = 'rgba(0, 170, 212, 0.1)';
            e.currentTarget.style.color = DS.color.aqua;
            e.currentTarget.style.transform = 'scale(1)';
          }} data-id="element-477" data-mp="3hpimg5nyihl5">
                {social.icon}
              </a>)}
          </div>

          {/* Barra inferior */}
          <div className="flex-col" style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '14px',
          flexWrap: 'wrap'
        }} data-id="element-478" data-mp="2of8k8b0qs77d">
            <span style={{
            fontFamily: DS.font.body,
            fontSize: '13px',
            color: DS.color.muted
          }} data-id="element-479" data-mp="3gxw45n405g6v">
              © {new Date().getFullYear()} Alinova · En línea con tu sonrisa
            </span>

            <div style={{
            display: 'flex',
            gap: '24px',
            alignItems: 'center',
            flexWrap: 'wrap',
            justifyContent: 'center'
          }} data-id="element-480" data-mp="1f8ykak21vbfp">
              <button type="button" onClick={() => setShowPrivacy(true)} style={{
              ...footerLinkStyle,
              fontSize: '13px'
            }} onMouseEnter={e => e.currentTarget.style.color = DS.color.teal} onMouseLeave={e => e.currentTarget.style.color = DS.color.muted} data-id="element-481" data-mp="hjn802t2o57x">
                Política de privacidad
              </button>
              <span style={{
              fontFamily: DS.font.body,
              fontSize: '13px',
              color: DS.color.muted
            }} data-id="element-482" data-mp="cfmb9pj9s60c">
                Colombia
              </span>
            </div>
          </div>
        </div>
      </footer>

      {/* Modal privacidad */}
      {showPrivacy && <div role="dialog" aria-modal="true" aria-label="Política de privacidad" style={{
      position: 'fixed',
      inset: 0,
      zIndex: 10000,
      background: 'rgba(11,31,36,0.75)',
      backdropFilter: 'blur(8px)',
      WebkitBackdropFilter: 'blur(8px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px'
    }} onClick={e => {
      if (e.target === e.currentTarget) setShowPrivacy(false);
    }} data-id="element-483" data-mp="qd13t34tktwj">
          <div style={{
        background: DS.color.white,
        borderRadius: '24px',
        width: '100%',
        maxWidth: '680px',
        maxHeight: '80vh',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '0 32px 100px rgba(0,0,0,0.20)',
        overflow: 'hidden'
      }} data-id="element-484" data-mp="1j1gi1ng4n86t">
            {/* Header modal */}
            <div style={{
          padding: '24px 32px',
          borderBottom: `1px solid ${DS.color.border}`,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexShrink: 0
        }} data-id="element-485" data-mp="2byr00a64smxf">
              <div data-id="element-486" data-mp="1y5rk472fsqpc">
                <div style={{
              fontFamily: DS.font.body,
              fontSize: '11px',
              fontWeight: 700,
              color: DS.color.teal,
              textTransform: 'uppercase',
              letterSpacing: '0.1em',
              marginBottom: '4px'
            }} data-id="element-487" data-mp="1y6klesimmo03">
                  Alinova
                </div>
                <div style={{
              fontFamily: DS.font.heading,
              fontWeight: 700,
              fontSize: '18px',
              color: DS.color.ink
            }} data-id="element-488" data-mp="ean8cconmj4y">
                  Política de privacidad
                </div>
              </div>
              <button type="button" onClick={() => setShowPrivacy(false)} aria-label="Cerrar política de privacidad" style={{
            background: DS.color.mint,
            border: 'none',
            borderRadius: '50%',
            width: '36px',
            height: '36px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            flexShrink: 0,
            transition: `background 0.2s ${DS.ease.smooth}`
          }} onMouseEnter={e => e.currentTarget.style.background = `${DS.color.aqua}30`} onMouseLeave={e => e.currentTarget.style.background = DS.color.mint} data-id="element-489" data-mp="a9boyowdiu57">
                <XIcon size={16} color={DS.color.tealDeep} aria-hidden="true" data-id="element-490" data-mp="1qgh67z1vsex" />
              </button>
            </div>

            {/* Contenido modal */}
            <div style={{
          padding: '32px',
          overflowY: 'auto',
          flex: 1
        }} data-id="element-491" data-mp="bpyyshrhn23t">
              {privacyContent.trim().split('\n').map((line, index) => {
            if (line.startsWith('POLÍTICA DE PRIVACIDAD')) {
              return <div key={index} style={{
                fontFamily: DS.font.heading,
                fontWeight: 700,
                fontSize: '15px',
                color: DS.color.tealDeep,
                marginBottom: '4px'
              }} data-id="element-492" data-mp="28j0sosrfctg2">
                        {line}
                      </div>;
            }
            if (line.startsWith('Última actualización')) {
              return <div key={index} style={{
                fontFamily: DS.font.body,
                fontSize: '12px',
                color: DS.color.muted,
                marginBottom: '24px'
              }} data-id="element-493" data-mp="18pkep7g6l8rr">
                        {line}
                      </div>;
            }
            if (/^\d+\./.test(line)) {
              return <div key={index} style={{
                fontFamily: DS.font.heading,
                fontWeight: 700,
                fontSize: '14px',
                color: DS.color.ink,
                marginTop: '20px',
                marginBottom: '8px'
              }} data-id="element-494" data-mp="ig1r15ym5run">
                        {line}
                      </div>;
            }
            if (line.startsWith('•')) {
              return <div key={index} style={{
                fontFamily: DS.font.body,
                fontSize: '13px',
                color: DS.color.body,
                lineHeight: 1.7,
                paddingLeft: '16px',
                marginBottom: '4px'
              }} data-id="element-495" data-mp="3lvqqnto4k6ky">
                        {line}
                      </div>;
            }
            if (line.trim() === '') return <div key={index} style={{
              height: '4px'
            }} data-id="element-496" data-mp="1xa2em7cw0zsd" />;
            return <p key={index} style={{
              fontFamily: DS.font.body,
              fontSize: '13px',
              color: DS.color.body,
              lineHeight: 1.75,
              margin: '0 0 8px'
            }} data-id="element-497" data-mp="1x7po35t2dh3p" data-mpi={index}>
                      {line}
                    </p>;
          })}
            </div>
          </div>
        </div>}
    </>;
}